import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import {
  StatsAndSocialProofTestData,
  UseStatsAndSocialProofTest,
  StatsAndSocialProofTestResult,
  StatsAndSocialProofTestVariants,
} from "./types";

const CUSTOM_RULE_ID = "homepageStatsAndSocialProof";

const useStatsAndSocialProofTest: UseStatsAndSocialProofTest = () => {
  const { isLoading, value } = useMonarchRule<{
    data: StatsAndSocialProofTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
    } as StatsAndSocialProofTestResult;
  }

  const variant: StatsAndSocialProofTestVariants = value?.data?.showTest
    ? "test"
    : "control";

  return {
    isLoading: false,
    variant,
    data: {
      showTest: value?.data?.showTest ?? false,
    },
  };
};

export default useStatsAndSocialProofTest;
